import { useStore } from "storev2/formStore";

async function onCreate(_, idRec, onClose) {
  const { findRecord, updateRecord } = useStore.getState();
  const model = "staff_supply.request.line";

  const { store } = findRecord(model, idRec);
  console.log("----------------------", store?.["size."]);

  console.log(store, "store");

  if (!store) {
    console.error("❌ No se encontró store para", idRec);
    return false;
  }

  const parentId = store["staff_supply.request"];
  if (!parentId) {
    console.error(
      "❌ No hay referencia a staff_supply.request en el store:",
      store,
    );
    return false;
  }

  const recForm = findRecord("staff_supply.request", parentId);
  if (!recForm) {
    console.error("❌ No se encontró recForm para", parentId);
    return false;
  }

  const idTemp = -(Date.now() + Math.floor(Math.random() * 1000));

  const newActiveLine = {
    id: idTemp,
    product: {
      id: store.product?.id,
      name: store.product?.name,
    },
    size: store.product?.["size."]
      ? { id: store.product["size."].id, name: store.product["size."].code }
      : undefined,
    quantity: store.quantity || 0,
  };

  const newStoreLine = {
    id: idTemp,
    product: store.product?.id,
    size: store.product["size."]?.id,
    quantity: store.quantity || 0,
  };

  const existingActive = Array.isArray(recForm.active?.lines)
    ? [...recForm.active.lines]
    : [];
  existingActive.push(newActiveLine);

  const existingStoreLines =
    recForm.store?.lines instanceof Map
      ? new Map(recForm.store.lines)
      : new Map();

  const createMap =
    existingStoreLines.get("create") instanceof Map
      ? new Map(existingStoreLines.get("create"))
      : new Map();

  createMap.set(idTemp, newStoreLine);
  existingStoreLines.set("create", createMap);

  recForm.active.lines = existingActive;
  recForm.store.lines = existingStoreLines;

  console.log("🧩 ACTIVE (antes de update):", recForm.active);
  console.log("📦 STORE (antes de update):", recForm.store);

  await updateRecord(
    recForm.active,
    recForm.store,
    "staff_supply.request",
    parentId,
  );

  if (typeof onClose === "function") onClose();
  return true;
}

function onChangeProduct(record, parentRecord) {
  const { product } = record.store;
  const { "size.": size } = product;
  if (size) {
    record.active.size = {
      id: size.id,
      code: size.code,
      rec_name: size.code,
    };
    record.store.size = size.id;
  }
}

function onDeleteLine(record) {
  console.log("onDeleteLine", record);

  return true;
}

function layoutLines() {
  let ctxView = {
    model: "staff_supply.request.line",
    row_selectable: false,
    table_action: ["add", "delete"],
    form_action: ["add", "delete", "edit"],
    access: {
      delete: () => true,
    },
    target: "request",
    domain: [],
    triggerCreate: onCreate,
    fields: {
      product: {
        type: "many2one",
        model: "product.template",
        required: true,
        attrs: [
          "id",
          "default_uom.name",
          "default_uom.category",
          "name",
          "list_price",
          "size.code",
          // "uom",
          "rec_name",
          "reference",
        ],
        reference: true,
        recSearch: () => [["size.code", "!=", null]],
        withChange: onChangeProduct,
      },

      quantity: {
        type: "integer",
        default: 1,
        editable: true,
      },
      size: {
        type: "many2one",
        model: "product.size",
        readOnly: true,
      },

      observation: { type: "text" },
      move: { type: "many2one", model: "stock.move", readOnly: true },
    },

    list: [
      { name: "product", width: "60%" },
      { name: "size", width: "60%" },
      { name: "quantity", width: "20%" },
    ],

    form: [
      {
        name: "fields",
        type: "grid",
        // col: "grid-cols-2",
        colSpan: "col-span-3",
        elements: [
          { name: "product", width: "60%" },
          // { name: "size", width: "20%" },
          { name: "quantity", width: "20%" },
        ],
      },
    ],
  };

  return ctxView;
}

export { layoutLines };
